module.exports = __webpack_public_path__ + "img/finance-badge.5a7e4789.png";